__turbopack_context__.v({
  "fade-in": "Slide-module-scss-module__5wHilq__fade-in",
  "image": "Slide-module-scss-module__5wHilq__image",
  "imageWrapper": "Slide-module-scss-module__5wHilq__imageWrapper",
  "isActive": "Slide-module-scss-module__5wHilq__isActive",
  "isPrev": "Slide-module-scss-module__5wHilq__isPrev",
  "isSlideShow": "Slide-module-scss-module__5wHilq__isSlideShow",
  "root": "Slide-module-scss-module__5wHilq__root",
});
